var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("a", { attrs: { href: _vm.unreadTopic.view_route } }, [
      _c("div", { staticClass: "pull-left text-center" }, [
        _vm.unreadTopic.type == "direct"
          ? _c("i", { staticClass: "fa fa-user text-light-blue" })
          : _vm._e(),
        _vm._v(" "),
        _vm.unreadTopic.type == "help"
          ? _c("i", { staticClass: "fa fa-question text-red" })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("h4", [
        _vm._v(_vm._s(_vm.topicSender) + "\n            "),
        _c("small", [
          _c("i", { staticClass: "fa fa-clock-o" }),
          _vm._v(" " + _vm._s(_vm.unreadTopic.sent_at_formatted)),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.unreadTopic.subject))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }